import React, { useEffect, useRef } from 'react';
import { routeMappings, SessionStore } from '../../constants';
import { Task } from '../interfaces';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Scroll to Task list label on return from any task item
 */
export const useScrollToTaskListLabel = (tasks: Task[]): React.RefObject<HTMLDivElement> => {
  const navigationType = useNavigationType();
  const location = useLocation();
  const taskListLabelRef = useRef<HTMLDivElement>(null);
  const onTaskListPage = location.pathname.includes(routeMappings['TASKLIST']);

  useEffect(() => {
    const isTaskInitialized = sessionStorage.getItem(SessionStore.isTaskInitialized);
    if (
      onTaskListPage &&
      isTaskInitialized &&
      taskListLabelRef.current &&
      !window.location.hash.includes(routeMappings['EXPVIDEOTASK'])
    ) {
      taskListLabelRef.current.scrollIntoView && taskListLabelRef.current.scrollIntoView();
      navigationType === 'POP' && sessionStorage.removeItem(SessionStore.isTaskInitialized);
    }
  }, [onTaskListPage, tasks, navigationType]);

  return taskListLabelRef;
};
